import React from 'react';
import { RiderType } from '../types/riderInfoDetail.types';
import '../styles/RiderTypeSection.css';

interface RiderTypeSectionProps {
    riderTypes: RiderType[];
    selectedRiderType: string;
    riderTypeLoading: boolean;
    onRiderTypeChange: (value: string) => void;
    onSave: () => void;
}

const RiderTypeSection: React.FC<RiderTypeSectionProps> = ({
                                                               riderTypes,
                                                               selectedRiderType,
                                                               riderTypeLoading,
                                                               onRiderTypeChange,
                                                               onSave,
                                                           }) => {
    return (
        <div className="section-margin">
            <div className="detail-card">
                <div className="detail-card-header">
                    <i className="fas fa-tag card-icon" />
                    <h3 className="card-title">라이더 유형</h3>
                </div>
                <div className="detail-card-body">
                    <div className="rider-type-form-row">
                        <label className="account-form-label" htmlFor="riderTypeSelect">
                            유형 선택
                        </label>
                        <div className="rider-type-input-group">
                            <select
                                id="riderTypeSelect"
                                className="form-input"
                                value={selectedRiderType}
                                onChange={(e) => onRiderTypeChange(e.target.value)}
                                disabled={riderTypeLoading}
                            >
                                <option value="">선택하세요</option>
                                {riderTypes.map((type) => (
                                    <option key={type.code} value={type.code}>
                                        {type.name}
                                    </option>
                                ))}
                            </select>
                            <button
                                className="save-btn"
                                type="button"
                                onClick={onSave}
                                disabled={!selectedRiderType || riderTypeLoading}
                            >
                                <i className="fas fa-save" />
                                저장
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RiderTypeSection;
